export const ROLE = {
  CUSTOMER: 'customer',
  PROVIDER: 'provider',
  OPERATOR: 'operator',
}
